// extracted by mini-css-extract-plugin
module.exports = {"decoration":"Decorations-module--decoration--7cf4F","topEdge":"Decorations-module--top-edge--3DNn2","bottomEdge":"Decorations-module--bottom-edge--1qdRz"};